import * as React from 'react'

import { DocRightRailViewItem } from 'types'

export interface ViewIcon {
  value: DocRightRailViewItem
  icon: React.ReactNode
}

export const COMMENT_VIEW = 'Comments'
export const TASKS_VIEW = 'Tasks'
export const INFORMATION_VIEW = 'Information'
export const INSERT_MENU_VIEW = 'InsertMenu'
export const ACTIVITY_FEED_VIEW = 'Activity'
export const RIGHT_RAIL_PARAM = 'right_rail'
export const LAYER_CHANGES_VIEW = 'LayerChanges'
export const TIMER_VIEW = 'Timer'
export const FORMAT_VIEW = 'Format'
export const AI_VIEW = 'AIAssistant'
